<template>
    <CardBase
        :config="content"
        :card-type="'icon'"
    />
</template>

<script setup lang="ts">
import type { HblSlot } from '@/utils/types'

const props = defineProps<{
    content: HblSlot,
}>()
</script>